import { Landing } from 'enum/design';
import StorageKeys from 'enum/storages.enum';
import Storages from 'storages';
import { bottomNavigationItems, getEffectiveMenuList } from 'utils/menuList';

export const getCurrentMultiListPosition = () => {
  const lists = getNavigationConfig().lists;

  const storedValue = Storages.MainStorage.getItem(StorageKeys.Keys.FOCUSINDEX) ?? 0;

  if (
    typeof storedValue === 'number' ||
    (typeof storedValue === 'string' && !storedValue.includes(','))
  ) {
    const index = parseInt(storedValue) || 0;
    return {
      listIndex: 0,
      itemIndex: Math.max(0, Math.min(index, (lists[0] || 1) - 1)),
    };
  }

  if (typeof storedValue === 'string' && storedValue.includes(',')) {
    const [listIdx, itemIdx] = storedValue.split(',').map(Number);
    const safeListIndex = Math.max(0, Math.min(listIdx || 0, lists.length - 1));
    const safeItemIndex = Math.max(0, Math.min(itemIdx || 0, (lists[safeListIndex] || 1) - 1));
    return {
      listIndex: safeListIndex,
      itemIndex: safeItemIndex,
    };
  }

  return { listIndex: 0, itemIndex: 0 };
};

export const getNavigationConfig = () => {
  const currentLandingPage = Storages.MainStorage.getItem(StorageKeys.Keys.ACTIVETEMPLATE);

  if (currentLandingPage === Landing.Warwick || currentLandingPage === Landing.WarwickV1) {
    return {
      lists: [getEffectiveMenuList(true).length || 0, bottomNavigationItems.length],
      betweenListsKey: 'vertical',
    };
  }

  return {
    lists: [getEffectiveMenuList(false).length || 0],
    betweenListsKey: 'vertical',
  };
};
